import axios, { AxiosInstance } from 'axios'
import { request, response } from './interceptors'
import CONSTANTS from '../../../constants'

const { API_BASE_URL } = CONSTANTS

type AxiosSetupOptions = {
  initialHeaders?: Record<string, string>
}

export const create = (options: AxiosSetupOptions): AxiosInstance => {
  const instance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/json',
      ...options.initialHeaders
    }
  })

  instance.interceptors.request.use(request)
  instance.interceptors.response.use(response)

  return instance
}
